import { render, staticRenderFns } from "./sousuo.vue?vue&type=template&id=a88ee06c&scoped=true"
import script from "./sousuo.vue?vue&type=script&lang=js"
export * from "./sousuo.vue?vue&type=script&lang=js"
import style0 from "./sousuo.vue?vue&type=style&index=0&id=a88ee06c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88ee06c",
  null
  
)

export default component.exports